import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AvatarBlueSvg from './icon-avatar-blue.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AvatarBlueSvg {...validProps} />;
}
SvgComponent.iconName = 'avatarBlue';

export const AvatarBlueIcon = svgIconWrapper(SvgComponent);
